export default __webpack_public_path__ + "static/media/irisity-logo-animation.4ea870d1.webm";